export const API_NAMES = {
  ETA: "eta",
  ESTA: "esta",
  DS160: "ds160",
  NZ: "nz",
  TRK: "trk",
  IND: "ind",
  IND_V2: "ind_v2",
  AUS: "aus",
  INV: "inv_letter",
  SCHENGEN: "schengen",
  SCHENGEN_V2: "schengen_v2",
  VN: "vn",
  DIVERSITY: "diversity",
  GE: "ge",
  SG: "sg",
  DS11: "ds11",
  DS82: "ds82",
  DS64: "ds64",
  SL: "sl",
  TSA: "tsa",
  SENTRI: "sentri",
  NEXUS: "nexus",
  QUICK_PHOTO: "quick_photo",
  CHINA: "china",
  EGYPT: "egypt",
  UK: "uk",
  AUS_V2: "aus_v2",
  CANADA: "canada",
};
